import React from 'react'
import PropTypes from 'prop-types'
import { PopoverFooter } from '../../../internal/components/PopoverFooter'
import { useThemeStyles } from '../../../theming'
import type { ButtonProps } from '../../Button'
import styles from './styles'

export interface ModalFooterProps {
  /**
   * The content to display in the Modal.Footer. If you pass 'children' and 'primaryButton', 'secondaryButton', or 'content, 'primaryButton', 'secondaryButton' and 'content' will be ignored.
   * @deprecated Will be removed in future release. Use 'primaryButton' and 'secondaryButton' props.
   */
  children?: React.ReactNode
  /**
   * Optional content to display alongside the footer buttons.
   */
  content?: React.ReactNode
  /**
   * Accepts custom data attributes.
   */
  'data-.*'?: string
  'data-qa'?: string
  /**
   * The primary action - accepts an @ds/ui Button component.
   */
  primaryButton?: React.ReactElement<ButtonProps>
  /**
   * The secondary action - accepts an @ds/ui Button component.
   */
  secondaryButton?: React.ReactElement<ButtonProps>
}

export function ModalFooter({
  children,
  content,
  'data-qa': dataQa,
  primaryButton,
  secondaryButton,
}: ModalFooterProps) {
  const sx = useThemeStyles(styles)

  if (children) {
    return (
      <div css={[sx.default.wrap, sx.children.wrap]} data-qa={dataQa}>
        {children}
      </div>
    )
  }

  return (
    <div css={sx.default.wrap} data-qa={dataQa}>
      <PopoverFooter
        content={content}
        data-qa={dataQa && `${dataQa}-popover-footer`}
        primaryButton={primaryButton}
        secondaryButton={secondaryButton}
      />
    </div>
  )
}

ModalFooter.displayName = 'Modal.Footer'

ModalFooter.propTypes = {
  children: PropTypes.node,
  content: PropTypes.node,
  primaryButton: PropTypes.element,
  secondaryButton: PropTypes.element,
}
